import "./style.scss";

import { type ReactNode } from "react";

type DetailPanelScrollProps = {
    children: ReactNode;
    className?: string;
};

const DetailPanelScroll = ({ children, className = "" }: DetailPanelScrollProps) => {
    return <div className={`detail-panel-scroll ${className}`.trim()}>{children}</div>;
};

export default DetailPanelScroll;
